import authCheckApp from "./authCheckApp";
import Vue from "vue";

/**
 * 换起更新弹窗（webview）
 * @since 1.0.0
 * @example
 *
 * apiCheckAppUpdate()
 */
function apiAppOpenService(data) {
  authCheckApp()
    .then(() => {
      // 发起请求
      window.WebViewJavascriptBridge.callHandler(
        "apiAppOpenService",
        data,
        async response => {
          console.log(response, 123123);
          return response;
        }
      );
    })
    .catch(err => {
      Promise.reject(err);
    });
}

export default apiAppOpenService;
